import useSWR from "swr";
import { ETH_AMOUNT } from "../../constants";

const ETH_ENDPOINT = "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd";
const KOLZ_ENDPOINT = "https://api.coingecko.com/api/v3/simple/price?ids=kolz&vs_currencies=usd";

const fetcher = (url: string) => fetch(url).then((res) => res.json());

const CACHE_DURATION = 600000; // 10 minutes

export default function usePrices() {
  const {
    data: ethData,
    error: ethError,
    isLoading: ethLoading,
  } = useSWR(ETH_ENDPOINT, fetcher, {
    dedupingInterval: CACHE_DURATION,
    revalidateOnFocus: false,
  });

  const {
    data: kolzData,
    error: kolzError,
    isLoading: kolzLoading,
  } = useSWR(KOLZ_ENDPOINT, fetcher, {
    dedupingInterval: CACHE_DURATION,
    revalidateOnFocus: false,
  });

  const baseEthPrice = (ethData?.ethereum?.usd || 0) * Number(ETH_AMOUNT);

  return {
    ethPrice: baseEthPrice,
    halfEthInKolz: baseEthPrice && kolzData?.kolz?.usd ? (0.5 * baseEthPrice) / kolzData.kolz.usd : 0,
    isLoading: ethLoading || kolzLoading,
    isError: ethError || kolzError,
  };
}
